import { useLayoutEffect, useRef } from "preact/hooks";
import css from "./navigationMobile.module.css";

const NavigationMobile = (props: MobileNavigationProps) => {
  const rootPath = "/c/account";
  const containerRef = useRef<HTMLUListElement>(null);
  const activeLinkRef = useRef<HTMLAnchorElement>(null);

  useLayoutEffect(() => {
    if (containerRef.current && activeLinkRef.current) {
      const container = containerRef.current;
      const activeLink = activeLinkRef.current;

      const containerWidth = container.clientWidth;
      const linkOffsetLeft = activeLink.offsetLeft;
      const linkWidth = activeLink.clientWidth;

      container.scrollLeft = linkOffsetLeft - containerWidth / 2 + linkWidth / 2;
    }
  }, [props.currentPath]);

  return (
    <div className={css.root}>
      <div className={css.tabs}>
        <div className={css.tabsIndicator}></div>
        <ul className={css.tabItems} ref={containerRef}>
          <li className={rootPath === props.currentPath ? css.activeTabItem : ""}>
            <a href={rootPath} ref={rootPath === props.currentPath ? activeLinkRef : null}>
              Mein INTERSPORT
            </a>
          </li>
          {props.navItems.map((navItem) => (
            <li
              class={css.tabItem}
              className={navItem.path === props.currentPath ? css.activeTabItem : ""}
            >
              <a
                key={navItem.path}
                href={navItem.path}
                ref={navItem.path === props.currentPath ? activeLinkRef : null}
              >
                {navItem.name}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

interface MobileNavigationProps {
  navItems: { path: string; name: string }[];
  currentPath?: string;
  logoutHandler: () => void;
}

export { NavigationMobile };
